// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameISOWeek as fn } from "../isSameISOWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameISOWeekWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default isSameISOWeekWithOptions;
